import axios from "axios";

//TODO: Need to add annotation for this function once the API is ready

const optOutQueryAndReqPinApi =
    "/participant-web-services/rest/partialauth/optOutQueryRequestPin/:optOut";

export const optOutQueryAndReqPin = async (isOptOutParams) => {
    try {
        const response = await axios.post(
            `${window.__baseApiUrl__}${optOutQueryAndReqPinApi}`,
            { optOut: isOptOutParams },
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        );
        return response.data;
    } catch (error) {
        console.log("Errororr", error);
        return error;
    }
};
